import React, { useEffect, useState } from "react";
import FormContextProvider from "../../context/FormContextProvider";
import SHFormTextField from "../form/SHFormTextField";
import ContentSection from "./ContentSection";
import SHFormFileUpload from "../form/SHFormFileUpload";
import DefaultSpacing from "./DefaultSpacing";
import { Box, Button, Typography } from "@mui/material";
import { useFormSubmit } from "../../hooks/useFormSubmit";
import DocumentList from "./DocumentList";
import { useTranslation } from "react-i18next";
import { useData } from "../../hooks/useData";
import SHAutocomplete, { Option } from "../form/SHAutocomplete";

interface Props {

}

const DocumentUpload : React.FC<Props> = () => {
    const {t} = useTranslation("common");
    const[submitForm, ,loading, ] = useFormSubmit(`upload`, "application/json");
    const [verifyRoleApiCall] = useData<{granted: boolean}>(`user/verify/role?r=change_data`, "GET", "application/json");
    const [uploadAllowed, setUploadAllowed] = useState(false); 
    const categories = t("common.category.list", {returnObjects: true}) as Option[];
    const languages = [{key: "de", label: t("common.language.de")}, {key: "en", label: t("common.language.en")}] as Option[];
    const alphabetList = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    const alphabet = alphabetList.map(a => {return {key: a, label: a} as Option});
    
    
    const years = [];
    const currentYear = new Date().getFullYear();
    for(let i = currentYear; i >= 1000; i--) {
        years.push({key: `${i}`, label: `${i}`});
    }

    useEffect(() => {
        verifyRoleApiCall((data) => setUploadAllowed(data?.granted??false), () => setUploadAllowed(false));
    }, [verifyRoleApiCall]);

    

    return <>
        <Typography variant='h1'>{t('common.documents.upload.page.title')}</Typography>
        <FormContextProvider name="documentUpload" onSubmit={(data) => {submitForm({fileName: data.fileName, category: data.category.key, year: data.year.key, language: data.language.key, file: data.file[0]})}}>
        {uploadAllowed === true && <Box sx={{margin: '1.5em 0'}}>
            <Typography variant='h2'>{t('common.documents.upload.title')}</Typography>
            
                <ContentSection>
                    <DefaultSpacing margin={{size: 'medium', applyTo: 'all'}}>
                        <SHFormTextField name="fileName" label={t("common.filename")} registerOptions={{required: true}} />
                    </DefaultSpacing>
                    <DefaultSpacing margin={{size: 'medium', applyTo: 'all'}}>
                        <SHAutocomplete name="year" label={t("common.year")} registerOptions={{required: true}} options={years} />
                    </DefaultSpacing>
                    <DefaultSpacing margin={{size: 'medium', applyTo: 'all'}}>
                        <SHAutocomplete name="category" label={t("common.category")} registerOptions={{required: true}} options={categories} />
                    </DefaultSpacing>
                    <DefaultSpacing margin={{size: 'medium', applyTo: 'all'}}>
                        <SHAutocomplete name="language" label={t("common.language")} registerOptions={{required: true}} options={languages} />
                    </DefaultSpacing>
                    <DefaultSpacing margin={{size: 'medium', applyTo: 'all'}}>
                        <SHFormFileUpload name="file" label={t("common.file")} registerOptions={{required: true}} />
                    </DefaultSpacing>
                
                <DefaultSpacing margin={{size: 'medium', applyTo: 'all'}}>
                    <Button type="submit" name="submitFile" variant="contained" disabled={loading}>Upload</Button>
                    </DefaultSpacing>
                </ContentSection>
            </Box>}
        </FormContextProvider>
        <FormContextProvider name="docListForm" onSubmit={() => {}} defaultValues={{
            docList: {
                year: years[0],
                category: categories[0],
                startsWith: alphabet[0],
                page: {key: '1', label: '1'},
                numberOfRows: {key: '20', label: '20'}
            }
        }}>
            
            <DocumentList categories={categories} alphabet={alphabet} years={years} />
        </FormContextProvider>
    </>
}

export default DocumentUpload;